export const ratingOptions = [
  { value: 1, label: "1 - Very Bad" },
  { value: 2, label: "2 - Bad" },
  { value: 3, label: "3 - Fair" },
  { value: 4, label: "4 - Good" },
  { value: 5, label: "5 - Very Good" },
];